import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { IconRegistryModule } from './utils/icon-registry.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
/** 
 * TODO :: Add in the long run every Component and module that is used in the app multiple times
 */
@NgModule({
  imports: [
    IconRegistryModule,
    MatCheckboxModule,
    FormsModule,
    TranslateModule.forChild({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: false
    })
  ],
  exports: [
    TranslateModule,
    MatCheckboxModule,
    FormsModule,
    IconRegistryModule
  ]
})

export class SharedModule {
  constructor(private translate: TranslateService) {
    translate.currentLang = '';
    if (translate.getBrowserLang() === 'fr') {
      registerLocaleData(localeFr, 'fr');
      translate.use('fr');
    } else {
      translate.use(navigator.language.slice(0, 2));
    }
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }

}
